const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileTopCurve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182.378,
    height: 121.05,
    viewBox: "0 0 182.378 121.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3031",
    d: "M5478.437 1467.089h146.275a339.2 339.2 0 0 1 36.1-31.115v-89.935a669.317 669.317 0 0 0-182.375 121.05z",
    style: {
      fill: "#bde131"
    },
    transform: "translate(-5478.437 -1346.039)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3032",
    d: "M5660.815 1408.328a669.257 669.257 0 0 0-92.371 58.761h92.371z",
    style: {
      fill: "#83c522"
    },
    transform: "translate(-5478.437 -1346.039)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileTopCurve);
export default __webpack_public_path__ + "static/media/mobile-top-curve.51c444830ab44cc1eacba94b9a6bec6a.svg";
export { ForwardRef as ReactComponent };